import { render } from "./ReviewTemplate.vue?vue&type=template&id=7a0bfa07&scoped=true"
import script from "./ReviewTemplate.vue?vue&type=script&lang=js"
export * from "./ReviewTemplate.vue?vue&type=script&lang=js"

import "./ReviewTemplate.vue?vue&type=style&index=0&id=7a0bfa07&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a0bfa07"]])

export default __exports__